import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Employee } from '@models/company';
import { LawFirmEmployee, LawFirmEmployeeType } from '@models/lawFirms';
import { LawFirm } from '@models/lawFirms';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { MatterDispatch } from '@state/matter';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { isEqual } from 'lodash';
import { GlobalDataManagementRequestDispatch } from 'src/app/global-data-management/state/global-data-management/global-data-management.request.dispatch';
import { NavigationService } from 'src/app/shared/services/nav/nav.service';

@Component({
	selector: 'app-edit-law-firm-side-form',
	templateUrl: './lawyer-edit-side-form.component.html',
	standalone: false,
})
export class EditLawyerSideFormComponent {
	public employee: Employee;
	public firm: LawFirm;

	@SelectSnapshot(SelectedMatter.id) saleId;
	constructor(
		private navigationService: NavigationService,
		private route: ActivatedRoute,
		private router: Router,
		private globalStoreDispatch: GlobalDataManagementRequestDispatch,
		private matterDispatch: MatterDispatch,
	) {
		const data = router.getCurrentNavigation()?.extras?.state;
		if (data) {
			this.employee = data.lawFirm.lawyer;
			this.firm = data.lawFirm;
		} else {
			this.navigationService.goBack(this.route);
		}
	}

	onSubmit(event: LawFirmEmployee) {
		event.role = LawFirmEmployeeType.LAWYER;
		if (event) {
			this.globalStoreDispatch.RequestLawFirmEmployeeChange(
				this.firm.id,
				event,
			);
			this.matterDispatch.CreateLawFirmEmployee(
				this.saleId,
				event,
				this.firm.id,
			);
		}

		this.navigationService.goBack(this.route);
	}

	onCancel() {
		this.navigationService.goBack(this.route);
	}
}
